import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Impact from '../components/Impact';
import { PageMetadata } from '../components/PageMetadata';

export default function ImpactPage() {
  return <div className="page-content">
    <PageMetadata title="Professional Impact | Elena Nurullina" description="Documented engineering results, recommendations, and verifiable professional achievements." />
    <div className="container"><Link to="/" className="back-link"><ArrowLeft size={18} aria-hidden="true" />Back to Home</Link></div>
    <Impact />
  </div>;
}
